export default __webpack_public_path__ + "static/gtc-group-71abf4649f88e92a188e5aacf4dfcbf6.png";